import { render, staticRenderFns } from "./behaviour-control.vue?vue&type=template&id=0a537808&scoped=true"
import script from "./behaviour-control.vue?vue&type=script&lang=ts"
export * from "./behaviour-control.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a537808",
  null
  
)

export default component.exports